import { Component, Input, Output, EventEmitter, signal, OnInit, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownStateService } from '../../../../../services/dropdown-state.service';

export interface DatasetOption {
  label: string;
  value: string;
  type: string;
}

@Component({
  selector: 'app-dataset-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dataset-dropdown.component.html',
  styleUrl: './dataset-dropdown.component.scss'
})
export class DatasetDropdownComponent implements OnInit, OnChanges {
  @Input() contentList: DatasetOption[] = [];
  @Input() selectedValue: DatasetOption | null = null;
  @Input() placeholder: string = 'Select';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() dropdownId: string = 'dataset-dropdown';
  @Output() onItemSelect = new EventEmitter<DatasetOption>();

  selectedDisplayText = signal<string>('');

  constructor(private dropdownStateService: DropdownStateService) {}

  ngOnInit() {
    this.updateSelectedDisplayText();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedValue'] || changes['placeholder']) {
      this.updateSelectedDisplayText();
    }
  }

  get isOpen(): boolean {
    return this.dropdownStateService.isDropdownOpen(this.dropdownId);
  }

  toggleDropdown() {
    if (!this.disabled && !this.isLoading) {
      if (this.isOpen) {
        this.dropdownStateService.closeDropdown();
      } else {
        this.dropdownStateService.openDropdown(this.dropdownId);
      }
    }
  }

  selectItem(item: DatasetOption) {
    this.selectedValue = item;
    this.onItemSelect.emit(item);
    this.dropdownStateService.closeDropdown();
    this.updateSelectedDisplayText();
  }

  closeDropdown() {
    this.dropdownStateService.closeDropdown();
  }

  private updateSelectedDisplayText() {
    if (this.selectedValue) {
      this.selectedDisplayText.set(this.selectedValue.label);
    } else {
      this.selectedDisplayText.set(this.placeholder);
    }
  }

  onOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dataset-dropdown')) {
      this.closeDropdown();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dataset-dropdown')) {
      this.closeDropdown();
    }
  }
}
